<template>
    <div>
        <PageLoader v-bind:storage="appLoading" />
        <ServerError v-if="ServerError" />
        <v-layout wrap justify-center px-5>
            <v-flex xs12 py-5 text-left>
                <span style="font-family: montserratBold; font-size: 20px; color: #000000">
                    Activity Log
                </span>
            </v-flex>
        </v-layout>
        <v-layout wrap justify-start px-5>
            <v-flex xs4 pb-5>
                <v-layout wrap>
                    <v-flex xs12 pb-4>
                        <span style="font-family: montserratSemiBold; font-size:15px; color: #000000">Please Select
                            From Date</span>
                    </v-flex>
                    <v-flex xs12>
                        <v-date-picker v-model="from" :show-current="false"></v-date-picker>
                    </v-flex>
                </v-layout>
            </v-flex>
            <v-flex xs4>
                <v-layout wrap>
                    <v-flex xs12 pb-4>
                        <span style="font-family: montserratSemiBold; font-size:15px; color: #000000">Please Select
                            To Date</span>
                    </v-flex>
                    <v-flex xs12>
                        <v-date-picker v-model="to" :show-current="false"></v-date-picker>
                    </v-flex>
                </v-layout>
            </v-flex>
            <!-- v-if="status == true" -->
            <v-flex xs4 text-left>
                <v-layout wrap>
                    <v-flex xs12 pt-10>
                        <v-btn dark color="#7CB9E8" @click="getData()">
                            <span style=" font-family: montserratBold;">Search</span>
                        </v-btn>
                    </v-flex>
                </v-layout>
                <v-layout wrap v-if="status == true">
                    <v-flex pt-5>
                        <a style="text-decoration:none"
                            :href="baseURL + '/user/log/view/v1?from=' + from + '&to=' + to + '&token=' + token"
                            target=_blank>
                            <span style="font-family: montserratSemiBold; font-size:17px; color:black">Download <v-icon
                                    color="blue">mdi-arrow-down-bold</v-icon></span></a>
                    </v-flex>
                </v-layout>
                <v-layout wrap>
                    <v-flex xs12 pt-3 text-left v-if="status == false">
                        <span style="font-family: montserratSemiBold; font-size:17px; color:black">{{ log }}</span>
                    </v-flex>
                </v-layout>
                <!-- <v-layout wrap pb-8 pt-5>
                    <v-flex xs12>
                        <v-card outlined width="500px" height="500px" style="overflow-x: auto;">
                            <pre style="font-family: montserratSemiBold;color:black">{{ log }}</pre>
                        </v-card>
                    </v-flex>
                </v-layout> -->
            </v-flex>
        </v-layout>
    </div>
</template>
<script>
import axios from "axios";
export default {
    data() {
        return {
            appLoading: false,
            ServerError: false,
            showSnackBar: false,
            msg: null,
            timeout: 5000,
            page: 1,
            currentPage: 1,
            pages: 0,
            limit: 10,
            log: "",
            dialog: true,
            menu: false,
            from: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
            to: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
            status: "",
            token: "",
        };
    },
    watch: {
        // from() {
        //     this.getData()
        // },
        // to() {
        //     this.getData()
        // }
    },
    mounted() {
        // this.getData();
        this.token = localStorage.getItem("token")
    },
    methods: {
        getData() {
            this.appLoading = true;
            axios({
                url: "/user/log/view/v1",
                method: "GET",
                headers: {
                    token: localStorage.getItem("token"),
                },
                params: {
                    from: this.from,
                    to: this.to
                },
            })
                .then((response) => {

                    if (response.data.status == false) {
                        this.appLoading = false;
                        this.status = false
                        this.log = response.data.msg
                    }
                    else {
                        this.appLoading = false;
                        this.status = true
                        this.log = response.data;
                    }
                })
                .catch((err) => {
                    // this.appLoading = false;
                    this.ServerError = true;
                    console.log(err);
                });
        },
    },
};
</script>
<style>
::-webkit-scrollbar {
    width: 20px;
}

/* Track */
::-webkit-scrollbar-track {
    box-shadow: inset 0 0 5px grey;
    border-radius: 10px;
}

/* Handle */
::-webkit-scrollbar-thumb {
    background: red;
    border-radius: 10px;
}
</style>